import React from 'react';
import OrderLayout from '../common/Order/OrderLayout';

const OrderHistory = () => {
	return (
		<div>
			<OrderLayout />
		</div>
	);
};

export default OrderHistory;
